module.exports = __webpack_public_path__ + "static/media/iphone_hero.1fe4872c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple/iphone_hero.png
// module id = 1133
// module chunks = 0